import { Typography } from '@material-ui/core'
import React from 'react'

export default function AppDescription() {
  return (
    <Typography variant='body1'>
      We calculate how many liters of paint it takes to paint your walls
      and suggest which paint cans you should buy to maximize your savings.
    </Typography>
  )
}
